import store from "../../store";

export default {
  canWrite(context) {
    const lcode = context.language;
    const language = store.state.metadata.contentLanguages.available.find((x) => x.languageCode == lcode);
    if (language && language.accessRights.write) return true;

    return false;
  },
  canRead(context) {
    const lcode = context.language;
    const language = store.state.metadata.contentLanguages.available.find((x) => x.languageCode == lcode && x.accessRights.read);
    return !!language;
  },
  canDelete(context) {
    const lcode = context.language;
    const language = store.state.metadata.contentLanguages.available.find((x) => x.languageCode == lcode);
    if (language && language.accessRights.delete) return true;
    return false;
  }
};
